import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

// Duty slip v2 (2026-09-26): two pricing modes, no overriddenRate. The v1
// services in Reservation.js are untouched; these hit the v2 routes that sit
// beside the v1 ones on the trip service. Both always resolve to the API's
// { success, data, message } envelope, so callers never see a raw error.
const env = runtimeEnv('B2B_API_BASE_URL');
const base = (tripId) => `${env}${API_ENDPOINT.reservation.editDutySlipApi}/${tripId}/v2`;
const json = { headers: { 'Content-Type': 'application/json' } };
const envelope = (err) =>
  err?.response?.data ?? { success: false, message: err?.message || 'Request failed' };

// Same body as the save; prices the edit on an in-memory copy, writes nothing.
export const previewDutySlipV2Service = async (tripId, payload) => {
  try {
    const res = await requestInstance.post(`${base(tripId)}/preview`, payload, json);
    return res?.data;
  } catch (err) {
    return envelope(err);
  }
};

export const editDutySlipV2Service = async (tripId, payload) => {
  try {
    const res = await requestInstance.patch(base(tripId), payload, json);
    return res?.data;
  } catch (err) {
    return envelope(err);
  }
};
